const results = [
  { icon: 'ri-line-chart-line', title: 'Рост продаж', desc: 'Конверсия растёт на 10-30%, средний чек — на 15-25%. Продажи становятся системными, а не случайными.' },
  { icon: 'ri-file-copy-2-line', title: 'Единые стандарты работы', desc: 'Все сотрудники работают по единым алгоритмам и скриптам. Качество сервиса стабильное независимо от того, кто общается с клиентом.' },
  { icon: 'ri-heart-pulse-line', title: 'Рост вовлечённости', desc: 'Сотрудники видят, что компания инвестирует в их развитие. Вовлечённость растёт, инициативность повышается, текучесть снижается.' },
  { icon: 'ri-chat-check-line', title: 'Повышение качества переговоров', desc: 'Менеджеры увереннее ведут переговоры, работают с возражениями, закрывают сделки. Клиенты чувствуют профессионализм.' },
  { icon: 'ri-user-add-line', title: 'Снижение текучести', desc: 'Обучение и развитие — один из главных факторов удержания персонала. Сотрудники остаются там, где они растут.' },
  { icon: 'ri-speed-up-line', title: 'Ускорение адаптации новичков', desc: 'Система наставничества и чек-листы сокращают время выхода на KPI в 1,5-2 раза. Новички быстрее начинают приносить прибыль.' },
  { icon: 'ri-bar-chart-grouped-line', title: 'Рост производительности', desc: 'Стандартизация процессов, чек-листы и алгоритмы повышают производительность на 15-25%. Меньше времени на «изобретение велосипеда».' },
  { icon: 'ri-user-star-line', title: 'Сильные руководители', desc: 'Руководители получают инструменты управления, делегирования, мотивации. Растёт качество управления и результаты отделов.' },
];

export default function CompanyResults() {
  return (
    <section id="results" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Что получает компания от измеримого обучения
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
          Когда компания переходит от обучения «для галочки» к обучению с измеримым результатом, меняется всё — от цифр в отчётах до атмосферы в коллективе
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {results.map((r, i) => (
            <div key={i} className="bg-white rounded-2xl p-6 border border-gray-100 hover:border-teal-300 hover:shadow-md transition-all group text-center">
              <div className="w-14 h-14 bg-teal-600 rounded-xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform">
                <i className={`${r.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{r.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{r.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}